export default {
    body: '#000',
    text: '#f0f0f0',
    // accent: '#1175d9',
    accent: '#ff5340',
    highlight: 'rgba(157, 82, 255, 0.45)',
}
